import React from "react";
import { CheckCircle2, Circle, Loader2 } from "lucide-react";
import { timelineState } from "@/lib/api";

export default function OrderTimeline({ order, dense = false }) {
  const steps = timelineState(order);
  const isCancelled = order?.status === "cancelled";

  if (isCancelled) {
    return (
      <div data-testid="order-timeline-cancelled" className="rounded-2xl border border-rose-400/30 bg-rose-400/10 p-5 text-rose-200">
        <div className="font-heading text-base font-bold">Objednávka byla zrušena</div>
        <div className="mt-1 text-sm">Pokud se jedná o omyl, prosím zavolejte Lence: +420 775 659 129.</div>
      </div>
    );
  }

  return (
    <ol className="relative" data-testid="order-timeline">
      {steps.map((s, idx) => {
        const isLast = idx === steps.length - 1;
        const state = s.state;
        return (
          <li key={s.key} className="relative pl-9 pb-5">
            {!isLast && (
              <span
                aria-hidden
                className={[
                  "absolute left-3 top-5 h-full w-px",
                  state === "done" ? "bg-emerald-400/60" : "bg-white/10",
                ].join(" ")}
              />
            )}
            <span
              className={[
                "absolute left-0 top-0 inline-flex h-6 w-6 items-center justify-center rounded-full border",
                state === "done" ? "border-emerald-400/50 bg-emerald-400/20 text-emerald-300" :
                state === "current" ? "border-amber-400/60 bg-amber-400/20 text-amber-300 animate-pulse" :
                "border-white/15 bg-white/[0.04] text-slate-500",
              ].join(" ")}
            >
              {state === "done" ? <CheckCircle2 className="h-3.5 w-3.5" /> :
                state === "current" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> :
                <Circle className="h-3 w-3" />}
            </span>
            <div className={dense ? "text-sm" : "text-base"}>
              <div className={[
                "font-semibold",
                state === "done" ? "text-emerald-200" :
                state === "current" ? "text-amber-200" : "text-slate-400",
              ].join(" ")}>
                {s.label}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
